import * as React from "react";
import { useTranslation } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";

import { GettingStartedLayout } from "components/products/GettingStartedLayout";
import { LicenseData } from "domain/licenses";
import { OnboardingProductType } from "domain/onboardings";
import { OnboardingImage, SoftwarePackage, Versions } from "domain/softwarePackages";
import { StoreState } from "store";

interface Props {
    licenses: Versions[];
    fetchedLicenses: LicenseData[];
    fetchedSoftwarePackages?: SoftwarePackage[];
    saveBmpOpOnboarded: (onboarded: boolean) => void;
    showBmpSetup: boolean;
    saveLastCompletedStep: (step: string) => void;
    fetchedOnboardingImages: OnboardingImage[];
}

const mapState = (state: StoreState) => ({
    theme: state.themeReducer.theme,
});

const connector = connect(mapState);

const GettingStarted = (props: Props & ConnectedProps<typeof connector>): JSX.Element => {
    const { t } = useTranslation();
    return (
        <>
            <GettingStartedLayout
                product={OnboardingProductType.BMPOP}
                visible={true}
                footerVisibility={false}
                extraHeaderText={t("Onboarding.bmpOp.productTitle")}
                title={t("Onboarding.gettingStartedFlow.title")}
                description={t("Onboarding.bmpOp.gettingStarted.description")}
                licenses={props.licenses}
                fetchedLicenses={props.fetchedLicenses}
                fetchedSoftwarePackages={props.fetchedSoftwarePackages}
                saveBmdeOnboarded={props.saveBmpOpOnboarded}
                showBmpSetup={props.showBmpSetup}
                saveLastCompletedStep={props.saveLastCompletedStep}
                fetchedOnboardingImages={props.fetchedOnboardingImages}
            />
        </>
    );
};

export default connector(GettingStarted);
